import { render, staticRenderFns } from "./MailBody.vue?vue&type=template&id=cf4f190e"
import script from "./MailBody.vue?vue&type=script&lang=js"
export * from "./MailBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports